import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Components/Home.js";
import About from "./Components/About";
import Services from "./Components/Services";
import Contact from "./Components/Contact";
import Blog from "./Components/Blog";
import FreeQuote from "./Components/FreeQuote";

function App() {
  return (
    <Router>
      <div>
    {/* <nav>
      <ul>
      <li><Link to="/">Home</Link></li>
      <li><Link to="About">About</Link></li>
      <li><Link to="Services">Services</Link></li>
      <li><Link to="Blog">Blog</Link></li>
      <li><Link to="Contact">Contact</Link></li>
      <li><Link to="FreeQuote">Free-Quote</Link></li>
      </ul>
    </nav> */}
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/free-quote" element={<FreeQuote />} />
    </Routes>
    </div>
    </Router>
  );
}

export default App;